"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutTheComposer() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="bg-dark-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-7xl">
        <h2 ref={headingRef} className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-dark mb-12 text-center transition-all duration-[var(--duration-slow)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          About the Composer
        </h2>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div ref={imageRef} className={`transition-all duration-[var(--duration-slow)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="card overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_sxs8o82a.png" alt="Philip Gray - Composer" className="w-full h-auto object-cover" />
            </div>
          </div>

          <div ref={contentRef} className={`space-y-6 text-foreground leading-relaxed transition-all duration-[var(--duration-slow)] delay-100 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="text-lg md:text-xl text-white">Philip Gray is a contemporary composer whose work bridges classical tradition with modern storytelling. Born into a family of musicians, he discovered an interest in composition at an early age. His writing reflects a respect for established musical forms alongside a curiosity for narrative-driven and contemporary approaches. Through his work, Gray explores the relationship between music and storytelling, contributing a thoughtful and measured voice to the current compositional landscape.</p>

            <p className="text-lg md:text-xl text-white"></p>

            <p className="text-lg md:text-xl text-white">The Mass represents the culmination of an extended period of artistic exploration. Commissioned as a work intended to engage contemporary audiences while drawing on centuries of liturgical tradition, the piece brings together choral writing, orchestral color, and electronic elements. These components are woven into a cohesive musical language that encourages reflection and sustained listening.</p>

            <p className="text-lg md:text-xl text-white">
              Through "The Mass," Philip Gray seeks to create a space where music
              becomes a vehicle for community, contemplation, and connection. A
              testament to the enduring power of art to illuminate the human
              experience.
            </p>
          </div>
        </div>
      </div>
    </section>;
}